module.exports = __webpack_public_path__ + "img/Menu-08.cad25692.png";